import { Routes, Route } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import styled from 'styled-components'
import { LanguageProvider } from './i18n/LanguageContext'
import { AuthProvider } from './contexts/AuthContext'
import { SubscriptionProvider } from './contexts/SubscriptionContext'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import useFirebaseAnalytics from './hooks/useFirebaseAnalytics'

// Pages
import HomePage from './pages/HomePage'
import PricingPage from './pages/PricingPage'
import LoginPage from './pages/LoginPage'
import MySubscriptionPage from './pages/MySubscriptionPage'
import PrivacyPolicyPage from './pages/PrivacyPolicyPage'
import SubscriptionSuccessPage from './pages/SubscriptionSuccessPage'
import SubscriptionCanceledPage from './pages/SubscriptionCanceledPage'
import UseCaseIndexPage from './pages/UseCaseIndexPage'
import UseCaseArticlePage from './pages/UseCaseArticlePage'

const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`

const MainContent = styled.main`
  padding-top: 84px;
  flex: 1;

  @media (max-width: 768px) {
    padding-top: 76px;
  }
`

const AppContent = () => {
  useFirebaseAnalytics()

  return (
    <AppContainer>
      <Helmet>
        <link rel="icon" href="/icon.png" />
      </Helmet>
      <div className="gradient-bg" aria-hidden="true" />
      <Navbar />
      <MainContent>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/mySubscription" element={<MySubscriptionPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/subscription-success" element={<SubscriptionSuccessPage />} />
          <Route path="/subscription-canceled" element={<SubscriptionCanceledPage />} />
          <Route path="/solutions" element={<UseCaseIndexPage />} />
          <Route path="/solutions/:slug" element={<UseCaseArticlePage />} />
        </Routes>
      </MainContent>
      <Footer />
    </AppContainer>
  )
}

const App = () => {
  return (
    <AuthProvider>
      <SubscriptionProvider>
        <LanguageProvider>
          <AppContent />
        </LanguageProvider>
      </SubscriptionProvider>
    </AuthProvider>
  )
}

export default App
